// Item #34 — tela de bloqueio total quando a mensalidade está vencida além da
// tolerância (mais de 15 dias após o vencimento). Modal com backdrop estático,
// sem botão de fechar, cobrindo qualquer tela ativa no momento em que o bloqueio
// é detectado (bootstrap ou no meio de uma sessão já aberta, via evento do
// interceptor axios).
import React, { useContext, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { GlobalContext } from "../../Utils/GlobalContext";
import EmpresasFinanceiroModal from "../Empresas/EmpresasFinanceiroModal";

function MensalidadePendenteBloqueio() {
  const { globalData } = useContext(GlobalContext);
  const [showFinanceiro, setShowFinanceiro] = useState(false);
  const situacao = globalData?.situacaoFinanceira;
  const bloqueado = Boolean(situacao?.bloqueado);

  if (!bloqueado) return null;

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("permissoes_grupo");
    window.location.href = "/login";
  };

  return (
    <>
      <Modal show={bloqueado} backdrop="static" keyboard={false} centered size="lg">
        <Modal.Body>
          <h4>Acesso bloqueado — mensalidade em aberto</h4>
          <p>
            Ainda não identificamos o pagamento da sua mensalidade, vencida há{" "}
            <strong>{situacao.diasEmAberto} dia(s)</strong>. Regularize o pagamento
            para voltar a utilizar o sistema.
          </p>
          <div className="d-flex gap-2 mt-3">
            <Button variant="success" onClick={() => setShowFinanceiro(true)}>
              Ir para área financeira
            </Button>
            <Button variant="outline-secondary" onClick={handleLogout}>
              Sair
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {showFinanceiro && (
        <EmpresasFinanceiroModal
          show={showFinanceiro}
          handleClose={() => setShowFinanceiro(false)}
          entidadeID={globalData.entidade_id}
          empresaNome={globalData.nome_entidade || "Entidade"}
        />
      )}
    </>
  );
}

export default MensalidadePendenteBloqueio;
